import { FaArrowRight } from 'react-icons/fa';
import { useState } from 'react';
import ArrowIcon from "../../Photos/Icons/arrowIcon.png";
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";

const Cource = ({ details, clsName }) => {

    const LinkTo = useNavigate();

    const [pos, setPos] = useState({ x: 0, y: 0, visible: false });

    const handleMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left - 20; // center drop (120px / 2)
        const y = e.clientY - rect.top - 20;

        setPos({ x, y, visible: true });
    };

    const handleLeave = () => {
        setPos((prev) => ({ ...prev, visible: false }));
    };
    return (
        <>
            <Helmet>
                
                <meta name="description" content={details.desc} />
            </Helmet>
            <div onClick={() => LinkTo(`/course/${details.courseId}`)} className="course">
                <div
                    className="imgageCourse"
                    onMouseMove={handleMove}
                    onMouseLeave={handleLeave}
                >
                    <div className='linear-gradient'></div>
                    <FaArrowRight className='circleArrow' />
                    <img src={details.img} alt={details.altDesc} className={`courseImg ${clsName}`} />
                    {pos.visible && (
                        <div
                            className="drop"
                            style={{ left: pos.x, top: pos.y }}
                        />
                    )}
                </div>
                <div className="CourseDetails">
                    <div className="courseDetailsLeft">
                        <p>{details.title}</p>
                        <p>{details.desc}</p>
                    </div>
                    {/* <FaArrowRight className='upArrow' /> */}
                    <img src={ArrowIcon} className='upArrow' alt='Arrow Icon Scaleup Academy' />
                </div>

            </div>
        </>
    )
}
export default Cource